import { makeStyles } from "e100-react-components";

export const useStyles = makeStyles(({ spacing, palette, typography }) => ({
  container: {
    padding: spacing(2),
  },
}));
